import { useEffect, useState } from 'react';

// Global state to track banner visibility
let bannerVisibilityListeners = [];
let isBannerVisible = false;
let bannerHeight = 46; // Default banner height
let navbarHeight = 80; // Default navbar height

export const useBannerVisibility = () => {
  const [isVisible, setIsVisible] = useState(isBannerVisible);
  const [height, setHeight] = useState(bannerHeight);
  const [navHeight, setNavHeight] = useState(navbarHeight);

  useEffect(() => {
    const handleVisibilityChange = (visible, newHeight, newNavHeight) => {
      setIsVisible(visible);
      if (newHeight) {
        setHeight(newHeight);
      }
      if (newNavHeight) {
        setNavHeight(newNavHeight);
      }
    };

    bannerVisibilityListeners.push(handleVisibilityChange);

    return () => {
      bannerVisibilityListeners = bannerVisibilityListeners.filter(
        listener => listener !== handleVisibilityChange
      );
    };
  }, []);

  return { isBannerVisible: isVisible, bannerHeight: height, navbarHeight: navHeight };
};

// Function to update banner visibility globally
export const setBannerVisibility = (visible, height = 56) => {
  isBannerVisible = visible;
  bannerHeight = height;
  
  // Notify all listeners
  bannerVisibilityListeners.forEach(listener => {
    listener(visible, height, navbarHeight);
  });
};

// Function to update navbar height globally
export const setNavbarHeight = (height) => {
  navbarHeight = height;
  
  // Notify all listeners
  bannerVisibilityListeners.forEach(listener => {
    listener(isBannerVisible, bannerHeight, height);
  });
};